export const PUBLIC_PATHS = ["/my", "/my/pw/verify", "/my/pw/change"]
